<template>
  <div>
    <div class="header row align-center">
      <!-- MENU MOBILE -->
      <div class="menu-mobile show-s grid-2-s" @click="showMenu = !showMenu">
        <button :class="showMenu ? 'close' : ''"></button>
        <ul class="menu column" :class="showMenu ? 'opened' : ''">
          <li>
            <router-link to="/supporter/dashboard">INÍCIO</router-link>
          </li>
          <li class="pendencies">
            <router-link to="/pendencias">
              <div class="pendencies-content">PENDÊNCIAS</div>
              <div v-if="user.pendenciasOpcionais && (user.pendencias && user.pendencias.length == 0)"
                class="ball purple">
                {{ user.pendenciasOpcionais }}
              </div>
              <div v-if="user.pendencias" class="ball">
                {{ user.pendencias }}
              </div>

            </router-link>
          </li>

          <li class="row" v-if="user.perfil != 'agregado_doutor'">
            ATALHOS
            <!-- <NewMark text="NOVO" /> -->
            <ul>
              <li>
                <router-link to="/supporter/candidaturas">Candidaturas</router-link>
              </li>
              <li @click="
                modal.show = true;
              modal.tab = 'comp';
              ">
                Competências
              </li>
              <li @click="
                modal.show = true;
              modal.tab = 'cert';
              ">
                Certificados
              </li>
              <li @click="
                modal.show = true;
              modal.tab = 'tool';
              ">
                Ferramentas
              </li>
              <router-link to="/supporter/extrato">
                <li>Extrato e Nota Fiscal</li>
              </router-link>
              <router-link to="/supporter/minha-equipe">
                <li class="my-supporters">Minha equipe</li>
              </router-link>
            </ul>
          </li>
          <router-link to="/parceiro/perfil">
            <li>PERFIL</li>
          </router-link>
          <router-link to="/parceiro/documentos">
            <li>DOCUMENTOS</li>
          </router-link>
          <!-- <router-link to="/parceiro/pagamento">
            <li>DADOS BANCÁRIOS</li>
          </router-link> -->
          <router-link to="/supporter/conta">
            <li>CONTA</li>
          </router-link>

          <li @click="SET_LOGOUT()">SAIR</li>
        </ul>
      </div>
      <!-- END MENU MOBILE -->

      <div class="row grid-2-g grid-3-m grid-8-s align-center justify-center-s">
        <img src="../assets/img/logo26.svg" class="logo show-g show-m" alt="Logo NetSupport" />
        <div class="logo-icon hide-g hide-m" :class="enable ? 'yes' : 'not'">
          <img src="../assets/img/logo26.svg" alt="NetSupport" @click="enableToggle()" />
        </div>
      </div>

      <div class="grid-8 hide-s">
        <ul class="menu row hide-s">
          <li :class="menu.dashboard ? 'active' : ''" @click="changeMenu('dashboard')">
            <router-link to="/supporter/dashboard">INÍCIO</router-link>
          </li>
          <li class="pendencies" :class="menu.pendency ? 'active' : ''" @click="changeMenu('pendency')">
            <div class="pendencies-content">
              <router-link to="/pendencias">PENDÊNCIAS</router-link>
            </div>
            <div v-if="user.pendenciasOpcionais" class="ball purple">
              {{ user.pendenciasOpcionais }}
            </div>
            <div v-if="user.pendencias" class="ball">
              {{ user.pendencias }}
            </div>

          </li>

          <li class="row" :class="menu.shortcut ? 'active' : ''" v-if="user.perfil != 'agregado_doutor' && user.perfil">
            ATALHOS
            <!-- <NewMark text="NOVO" /> -->
            <i class="arrow-down fa fa-chevron-down"></i>
            <ul>
              <li @click="changeMenu('shortcut')">
                <router-link to="/supporter/candidaturas">Candidaturas</router-link>
              </li>
              <li @click="
                modal.show = true;
              modal.tab = 'comp';
              changeMenu('shortcut');
              ">
                Competências
              </li>
              <li @click="
                modal.show = true;
              modal.tab = 'cert';
              changeMenu('shortcut');
              " class="row align-center">
                Certificados &nbsp;
                <!-- <NewMark /> -->
              </li>
              <li @click="
                modal.show = true;
              modal.tab = 'tool';
              changeMenu('shortcut');
              " class="row align-center">
                Ferramentas &nbsp;
                <!-- <NewMark /> -->
              </li>
              <router-link to="/supporter/extrato" @click="changeMenu('shortcut')">
                <li :class="menu.extract ? 'active-sub' : ''">Extrato e Nota Fiscal</li>
              </router-link>
              <li class="my-supporters" :class="menu.mysupporters ? 'active-sub' : ''"
                @click="changeMenu('mysupporters')">
                <router-link to="/supporter/minha-equipe">MINHA EQUIPE
                </router-link>
              </li>
            </ul>
          </li>

        </ul>
      </div>

      <div class="grid-2-g grid-3-m grid-2-s row align-center justify-end">
        <div class="enable row hide-s" v-if="user.perfil !== 'agregado_doutor'">
          <div class="range" :class="enable ? 'yes' : 'not'" @click="enableToggle()">
            <div class="pin"></div>
          </div>
          <span :class="enable ? 'activate' : 'unable'" @click="enableToggle()">
            {{ enable ? "DISPONÍVEL" : "INDISPONÍVEL" }}
          </span>
        </div>
        <Notify />
      </div>

      <div class="grid-2-g grid-3-m hide-s">
        <UserTab perfil="/parceiro/perfil" account="/supporter/conta" />
      </div>
    </div>
    <div class="attendance-status" :class="enable ? 'yes' : 'not'" v-if="showStatusEnable">
      {{ enable ? "DISPONÍVEL" : "INDISPONÍVEL " }}<br />
      <span v-if="enable">Você está disponível para atendimento</span>
      <span class="hide-s" v-if="!enable">Clique na chave de disponibilidade acima para ficar disponível para
        atendimento.</span>
      <span class="hide-m hide-g" v-if="!enable">Clique no icone da NS acima para ficar disponível para
        atendimento.</span>
    </div>
    <Modal :modal="modal" />
    <Modal :modal="modalGuide" />
  </div>
</template>

<script>
import UserTab from "@/components/UserTab.vue";
import Notify from "@/components/Notify.vue";
import Modal from "@/components/Modal.vue";


import { mapActions, mapGetters } from "vuex";
export default {
  name: "HeaderSupporter",
  components: {
    UserTab,
    Notify,
    Modal,
  },
  data() {
    return {
      showMenu: false,
      showStatusEnable: false,
      menu: {
        dashboard: false,
        pendency: false,
        shortcut: false,
        mysupporters: false,
        extract: false,
      },
      modal: {
        show: false,
        layout: "CompCertTool",
      },
      modalGuide: {
        show: false,
        layout: "AttendanceButton",
      },
    };
  },
  methods: {
    ...mapActions("user", ["SET_LOGOUT", "GET_PENDENCIES"]),
    ...mapActions("supporter", ["ENABLE", "ENABLE_GET"]),
    enableToggle() {
      this.ENABLE(!this.enable);
      this.showStatusEnable = true;
      setTimeout(() => (this.showStatusEnable = false), 5000);
    },
    changeMenu(active) {
      this.menu = {
        dashboard: false,
        pendency: false,
        shortcut: false,
        mysupporters: false,
        extract: false,
      };
      if (active) this.menu[active] = true;
    },
  },
  computed: {
    ...mapGetters("user", ["user"]),
    ...mapGetters("supporter", ["enable"]),
  },
  beforeMount() {
    this.ENABLE_GET();
    this.GET_PENDENCIES();
  },
  mounted() {
    /* this.modalGuide.show = this.user.ajuda_guiada_disponibilidade; */
    if (
      !localStorage.getItem("atendimento") ||
      localStorage.getItem("atendimento") !== "false"
    )
      this.modalGuide.show = this.user.ajuda_guiada_disponibilidade;
  },
};
</script>

<style lang="scss">
@use "@/assets/scss/vars.scss" as *;

.attendance-status {
  color: $font-color;
  font-family: verdana;
  text-align: center;
  padding: 5px 0px;
  font-weight: 700;
  font-size: 16px;
  border-radius: 0 0 23px 23px;
  z-index: 999;

  span {
    font-size: 14px;
  }

  &.not {
    background: $red;
  }

  &.yes {
    background: $green-2;
  }

  @media (max-width: $small) {
    top: 99px;
    position: absolute;
    width: 100%;
  }
}

.header {
  height: 70px;
  background: #fff;
  box-shadow: 0px 0px 4px rgba($purple, 0.1);
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;

  @media (max-width: $small) {
    height: 100px;
  }

  .enable {
    color: $font-color;
    margin-top: 10px;
    margin-right: 25px;
    font-weight: bold;
    font-size: 11px;
    cursor: pointer;
    letter-spacing: 1.6px;

    @media (max-width: $medium) {
      font-size: 9px;
    }

    .unable {
      color: $red;
    }

    .activate {
      color: $green-1;
    }

    .range {
      .pin {
        width: 23px;
        height: 23px;
        background: white;
        border-radius: 50%;
        box-shadow: $shadow;
        margin-top: -9px;
      }

      &.not {
        background: $red-3;

        .pin {
          border: 2px solid $red-3;
        }
      }

      &.yes {
        background: $green-2;
        color: $font-color;

        .pin {
          margin-left: 24px;
          border: 2px solid $green-2;
        }
      }

      box-shadow: inset 0px 0px 3px #444;

      width: 50px;
      height: 10px;
      border-radius: 25px;
      margin: 0px 5px;
      margin-right: 8px;
    }

    .pin {
      margin-top: -18px;
      width: 40px;
    }
  }

  .logo {
    width: 353px;
    height: 50px;
    display: none;

    @media (min-width: $medium) {
      margin-left: -50px;
    }

    @media (min-width: $small) and (max-width: $medium) {
      width: 110px;
      height: 23px;
    }
  }

  .logo-icon {
    width: 53px;
    padding: 12px;
    border-radius: 50%;
    cursor: pointer;

    img {
      width: 100%;
    }

    &.not {
      border: 4px solid $red-3;
    }

    &.yes {
      border: 4px solid $green-2;
    }
  }

  .menu {
    list-style: none;
    color: $font-color;
    font-size: 13px;
    font-weight: bold;

    &>li {
      margin-right: 25px;
      padding: 25px 0px;

      @media (min-width: $small) and (max-width: $medium) {
        font-size: 12px;
      }

      a {
        padding: 20px 0px;
        height: 25px;

        &:hover {
          color: $supporter-1;
        }
      }

      @media (min-width: $large) {
        margin-right: 50px;
      }

      &:hover {
        /*  border-top: 1px solid #fff; */
        cursor: pointer;

        & ul {
          display: block;

          a:hover {
            color: $font-color;
          }

          li {
            padding: 15px 25px;
            text-transform: uppercase;
            color: $font-color;

            &:hover {
              background: $supporter-1;
              color: white;
            }
          }
        }
      }

      ul {
        display: none;
        list-style: none;
        position: absolute;
        background:rgba(white,.7);
        margin-top: 38px;
        margin-left: -40px;
        padding: 13px 6px;
        border-radius: 0 0 9px 9px;
      }
    }

    .arrow-down {
      margin-left: 10px;
      font-size: 12px;
      color: $font-color;
    }

    .active {
      border-top: 3px solid $supporter-1;
      color: $supporter-1;
    }

    .active-sub {
      color: $font-color;
      background: $purple;

      &:hover {
        color: $font-color;
      }
    }

    .pendencies {
      & i {
        margin-right: 7px;
        font-size: 14px;
      }

      .ball {
        float: right;
        border-radius: 50%;
        font-size: 18px;
        min-width: 19px;
        height: 19px;
        line-height: 20px;
        font-weight: bold;
        text-align: center;
        margin-top: -30px;
        margin-right: -18px;
        color: white;
        background: $red-1;
        box-shadow: $shadow;
        border: 1.3px solid $red-1;

        &.purple {
          background: $purple;
          border: 1.3px solid $purple;
        }
      }
    }

    &-mobile {
      color: $font-color;
      display: none;
      cursor: pointer;

      .menu {
        background: white;
        width: 100%;
        position: absolute;
        top: -190%;
        z-index: 990;
        font-size: 0.8rem;
        border-radius: 0 0 21px 21px;

        &.opened {
          top: 93px;
        }

        li {
          padding: 1rem 20px;

          a {
            padding: 20px 0px;
          }
        }

        ul {
          padding: 0px;
          background: none;

          li {
            padding: 20px 0px;
            padding-left: 50%;
            padding-right: 0px;
            text-transform: uppercase;
            width: 130%;
          }
        }
      }

      button {
        margin: 15% auto;
        display: block;
        width: 45px;
        height: 45px;
        position: relative;
        display: block;
        width: 18px;
        height: 2px;
        background: #fff;
        border-radius: 3px;
        cursor: pointer;
        transition: transform 0.2s ease;

        &::before {
          content: "";
          display: block;
          position: absolute;
          width: 18px;
          height: 2px;
          top: -12px;
          left: 0px;
          background: #fff;
          border-radius: 3px;
          transition: transform 0.3s ease;
        }

        &::after {
          content: "";
          display: block;
          position: absolute;
          width: 18px;
          height: 2px;
          left: 0px;
          top: 12px;
          background: #fff;
          border-radius: 3px;
          transition: transform 0.3s ease;
        }

        &.close {
          left: 5px;
          position: relative;
          display: block;
          width: 0;
          height: 0;
          background: transparent;
          transform: rotate(-180deg);

          &::before {
            content: "";
            display: block;
            position: absolute;
            width: 18px;
            height: 2px;
            top: 0;
            background: #fff;
            transform: rotate(-45deg);
            transition: transform 0.3s ease;
          }

          &::after {
            content: "";
            display: block;
            position: absolute;
            width: 18px;
            height: 2px;
            top: 0;
            background: #fff;
            transform: rotate(45deg);
            transition: transform 0.3s ease;
          }
        }
      }

      i {
        margin-left: 20px;
      }

      & ul {
        .active {
          border-bottom: none;
        }
      }

      & ul li ul {
        display: block;
        position: inherit;
        margin-left: -100px;
      }

      .pendencies {
        & i {
          margin-right: 7px;
          font-size: 14px;
        }

        .ball {
          float: right;
          border-radius: 50%;
          font-size: 12px;
          min-width: 17px;
          height: 17px;
          line-height: 14px;
          font-weight: bold;
          text-align: center;
          margin-top: -30px;
          margin-right: -15px;
          color: $font-color;
          background: $red-1;
        }
      }
    }
  }
}
</style>
